// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3VQRb","resort":"styles_resort__3fQU5","signDesktop":"styles_signDesktop__39Fs2","signTablets":"styles_signTablets__2I0J-"};